// import ApolloClient, { InMemoryCache } from 'apollo-boost'
// // const cache=new InMemoryCache
// export const apolloClient = new ApolloClient({
//   uri: 'http://192.168.2.217:8080/graphql'
//   // ,cache
// })
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { getDataServer } from '../views/utility/utility'

const dataServer = getDataServer()
// console.log(dataServer)
const httpLink = createHttpLink({
  uri: dataServer + '/graphql'
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token')
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
})
